import { Box, Divider, Stack, Typography } from "@mui/material";
import { TEXT_SECONDARY } from "@/config/mui/colorPalette";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";
import { MoxieImage } from "../images/moxieImage";
import TopBarWrapper from "./topBarWrapper";

export type FullWidthTopBarProps = {
  name: string;
  barTitle?: string;
  logoUrl: string;
  customizationEnabled: boolean;
  children?: React.ReactNode;
};

export const FullWidthTopBar = ({
  name,
  logoUrl,
  barTitle,
  children,
  customizationEnabled,
  onLogoClick,
}: FullWidthTopBarProps & {
  onLogoClick?: () => void;
}) => {
  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  return (
    <TopBarWrapper
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Stack
          sx={{
            gap: 2,
            flexDirection: "row",
            alignItems: "center",
          }}
          divider={<Divider orientation="vertical" sx={{ height: "16px" }} />}
        >
          <Box
            sx={{
              gap: 1,
              display: "flex",
              flexDirection: "row",
              cursor: onLogoClick ? "pointer" : "default",
            }}
            onClick={onLogoClick}
          >
            {customizationEnabled && logoUrl && (
              <MoxieImage
                alt={`${name} logo`}
                imageUrl={logoUrl}
                width={40}
                height={40}
                style={{
                  borderRadius: "12px",
                }}
              />
            )}
            <Typography
              variant={isMobile ? "h3" : "subtitleDefault"}
              sx={{
                alignContent: "center",
              }}
            >
              {name}
            </Typography>
          </Box>
          {!isMobile && (
            <Typography
              variant="paragraphSmall"
              sx={{
                color: TEXT_SECONDARY,
              }}
            >
              {barTitle}
            </Typography>
          )}
        </Stack>
        {children ? children : <Box sx={{ height: "40px", width: "40px" }} />}
      </Box>
    </TopBarWrapper>
  );
};
